import { Trees, Wind, Cloud } from 'lucide-react';

export default function Loader({ children, isLoading, message = false}) {
  return (
    <div style={{ position: 'relative' }}>
      {children}

      {isLoading && (
        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
          gap: '10px'
        }}>
          <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 11,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}>
          <div className="landscape-scene">
            <Cloud className="cloud cloud-1" size={18} />
            <Cloud className="cloud cloud-2" size={14} />
            <div className="trees-row">
              <Trees className="tree tree-1" size={32} />
              <Trees className="tree tree-2" size={28} />
              <Trees className="tree tree-3" size={32} />
            </div>
            <Wind className="wind-line" size={20} />
          </div>
          {message && (
            <span style={{ fontSize: '12px', color: '#9ca3af', letterSpacing: '0.08em', fontFamily: 'sans-serif' }}>
              {message}
            </span>
          )}
          </div>
        </div>
      )}

      <style>{`
        .landscape-scene {
          position: relative;
          width: 90px;
          height: 60px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }

        /* Clouds drifting across */
        .cloud {
          position: absolute;
          color: #d1d5db;
        }
        .cloud-1 {
          top: 0px;
          animation: drift 4s ease-in-out infinite;
        }
        .cloud-2 {
          top: 6px;
          animation: drift 4s ease-in-out infinite 1.5s;
          opacity: 0.6;
        }

        /* Trees swaying */
        .trees-row {
          display: flex;
          align-items: flex-end;
          gap: 4px;
          position: absolute;
          bottom: 0;
        }

        .tree { color: #4a7c59; transform-origin: bottom center; }
        .tree-1 { animation: sway 3s ease-in-out infinite; }
        .tree-2 { animation: sway 3s ease-in-out infinite 0.4s; }
        .tree-3 { animation: sway 3s ease-in-out infinite 0.8s; }

        /* Wind line floating through */
        .wind-line {
          position: absolute;
          bottom: 18px;
          left: -4px;
          color: #bfdbfe;
          animation: windPass 3s ease-in-out infinite;
          opacity: 0;
        }

        @keyframes drift {
          0%, 100% { transform: translateX(-8px); }
          50%       { transform: translateX(8px); }
        }

        @keyframes sway {
          0%, 100% { transform: rotate(-4deg); }
          50%       { transform: rotate(4deg); }
        }

        @keyframes windPass {
          0%   { opacity: 0; transform: translateX(0px); }
          30%  { opacity: 1; }
          100% { opacity: 0; transform: translateX(60px); }
        }
      `}</style>
    </div>
  );
}